import * as yup from "yup";
import { useFormik as formik } from "formik";

const validationSchema = yup.object({
    email: yup.string().email("Ingrese un email valido").max(150, "Debe tener como maximo 150 caracteres"),
    telefono: yup.string().matches(/^\+?[0-9]+( [0-9]+)*$/, { message: "Ingrese solo numeros y espacios, opcionalmente precedidos por +", excludeEmptyString: true }).max(15, "Debe tener como maximo 15 caracteres"),
});

export const formikValidation = (setNewContacto, usuario) => formik({
    initialValues: {
        email: usuario && usuario.usuarioMail ? usuario.usuarioMail : "",
        telefono: usuario && usuario.usuarioTelefonoCelular ? usuario.usuarioTelefonoCelular : "",
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => setNewContacto(values)
});
